export const General = {
  generalPolicyPrivacy: '#',
  policyPrivacy: '#',
  instagram: 'https://www.instagram.com/monspius/',
  facebook: 'https://www.facebook.com/MonsPius ',
  googleApiKey: 'AIzaSyApBEBocUtOkfjXRZYfZ21eszsl4la6Xd0',
  parajanov: 'https://parajanov.com.ua/',
  babogardens: 'https://babogardens.com.ua/',
  libraria: 'https://libraria.com.ua/',
  centaura: 'https://centaura.com.ua/',
  phone: '0 (32) 235-60-60',
  gAnalyticId: 'G-F6E6J0TG85',
}
